import React from 'react';
import { useAppDispatch } from '../../../store/hooks';
import { UpdateBanks, GetBankList } from '../../../store/NTX/Banks/banksSlice';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import { AddBankSchema } from '../../ValidationForm/validationSchema';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
interface props {
  item: any;
}

const Update: React.FC<props> = ({ item }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { HasPermission } = usePermissions();
  const formik = useFormik({
    initialValues: {
      name: item ? item.name : '',
      name2: item.name2 ?? '',
      code: item.code ?? '',
      note: item.note ?? ''
    },
    enableReinitialize: true,
    validationSchema: AddBankSchema(t),
    onSubmit: values => {
      dispatch(
        UpdateBanks({
          id: item.id,
          name: values.name,
          name2: values.name2,
          code: values.code,
          note: values.note
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Edit' });
            document.getElementById('closeModalForm')?.click();
            // dispatch(GetBankList());
            formik.resetForm();
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => {
          formik.setSubmitting(false);
        });
    }
  });
  const { values, errors, touched } = formik;

  return (
    <Form onSubmit={formik.handleSubmit}>
      <div className='row'>
        <div className='col-xl-4'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('LocalName')}</label>
            <Form.Control
              className='form-control  '
              type='text'
              autoComplete='off'
              name='name2'
              onChange={formik.handleChange}
              value={formik.values.name2}
              isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
            />
            {touched.name2 && errors.name2 && typeof errors.name2 === 'string' && (
              <div className='text-danger small'>{errors.name2}</div>
            )}
          </div>
        </div>
        <div className='col-xl-4'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('GlobalName')}</label>
            <Form.Control
              className='form-control  '
              type='text'
              autoComplete='off'
              name='name'
              onChange={formik.handleChange}
              value={formik.values.name}
              isInvalid={!!(formik.touched.name && formik.errors.name)}
            />
            {touched.name && errors.name && typeof errors.name === 'string' && (
              <div className='text-danger small'>{errors.name}</div>
            )}
          </div>
        </div>

        <div className='col-xl-4'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Code')}</label>
            <Form.Control
              className='form-control'
              type='text'
              autoComplete='off'
              name='code'
              onChange={formik.handleChange}
              value={values.code}
              isInvalid={!!(touched.code && errors.code)}
            />
            {/* <div className="text-danger small">{touched.code && errors.code}</div> */}
            {touched.code && errors.code && typeof errors.code === 'string' && (
              <div className='text-danger small'>{errors.code}</div>
            )}
          </div>
        </div>

        <div className='col-xl-12'>
          <div className='form-group mb-3'>
            <label className='form-label'>{t('Note')}</label>
            <Form.Control
              className='form-control  '
              type='text'
              autoComplete='off'
              name='note'
              onChange={formik.handleChange}
              value={formik.values.note}
            />
          </div>
        </div>
      </div>

      <div className='text-center'>
        <div className='d-flex justify-content-between gap-2'>
          {HasPermission('EditHrPerBank') && (
            <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg btn-theme mb-1 w-100'>
              {formik.isSubmitting ? (
                <div className='spinner-border spinner-border-sm me-2'></div>
              ) : (
                <i className='fas fa-save fa-lg fa-fw me-2'></i>
              )}
              {t('Save')}
            </button>
          )}
          <button
            type='button'
            className='btn btn-lg  btn-default mb-1 w-100'
            data-bs-dismiss='modal'
            id='closeModalJob'
          >
            <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
          </button>
        </div>
      </div>
    </Form>
  );
};

export default Update;
